module.exports = __webpack_public_path__ + "img/banner-37.e450701c.jpg";